import { defineMessages } from 'react-intl';

export const freightStatusBadgeMessages = defineMessages({
  pending: {
    defaultMessage: 'Pending Pickup',
    id: 'e1xuOP',
    description: 'Freight status badge label for a shipment the carrier has not picked up yet',
  },
  inTransit: {
    defaultMessage: 'In Transit',
    id: '4t8qqD',
    description: 'Freight status badge label for a shipment in transit',
  },
  outForDelivery: {
    defaultMessage: 'Out for Delivery',
    id: 'MkgZ9z',
    description: 'Freight status badge label for a shipment out for final delivery',
  },
  delivered: {
    defaultMessage: 'Delivered',
    id: 'BRO0CE',
    description: 'Freight status badge label for a delivered shipment',
  },
  exception: {
    defaultMessage: 'Exception',
    id: 'j3/i8I',
    description: 'Freight status badge label for a shipment with a delivery exception',
  },
  voided: {
    defaultMessage: 'Voided',
    id: '859qYO',
    description: 'Freight status badge label for a voided shipment',
  },
});
